import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import request from "../../request/request";

export const createUser = createAsyncThunk('createUser', async (object, { rejectWithValue }) => {
    try {
      const response = await request('/api/v1/tenants/user-create', {
        method: 'POST',
        body: object,
        auth: true,
      });

      if (!response?.data) {
        throw new Error(response?.message || "User creation failed");
      }
      
      return response;
    } catch (err) {
      toast.error(err?.message || "Something went wrong!");
      return rejectWithValue(err?.message || "Something went wrong!");
    }
  }
);
